<template>
  <div>
    <v-menu v-model="isDropdownOpen" offset-y>
      <template v-slot:activator="{ props }">
        <v-avatar v-bind="props" size="40">
          <v-img :src="profileStore.ProfileData.image || noImage" alt="admin" class="ma-2 logo-icon" />
        </v-avatar>
      </template>

      <v-card min-width="260" class="profile-card">
        <!-- Card Header -->
        <v-sheet class="profile-header pa-4 d-flex align-center">
          <v-avatar size="45" class="me-3">
            <v-img :src="profileStore.ProfileData.image" alt="admin" />
          </v-avatar>
          <div>
            <h4 class="profile-name mb-1"> {{ profileStore.ProfileData.first_name }} {{
              profileStore.ProfileData.last_name }}
            </h4>
            <!-- <p class="profile-role">{{ profileStore.ProfileData.role }}</p> -->
          </div>
        </v-sheet>

        <!-- <v-divider></v-divider> -->

        <!-- Menu Items -->
        <v-list class="profile-menu">
          <v-list-item link to="/my-profile" @click="closeDropdown">
            <v-icon class="me-3 text-primary">mdi-account-circle</v-icon>
            My Profile
          </v-list-item>
          <v-list-item link to="/dashboard" @click="closeDropdown">
            <v-icon class="me-3 text-green">mdi-credit-card</v-icon>
            Billing
          </v-list-item>
          <!-- </v-list> -->

          <!-- <v-divider></v-divider> -->

          <!-- <v-list class="profile-menu"> -->
          <v-list-item link to="/support" @click="closeDropdown">
            <v-icon class="me-3 text-blue">mdi-lifebuoy</v-icon>
            Support
          </v-list-item>
          <!-- <v-list-item link to="/authentication/login" @click="closeDropdown">
            <v-icon class="me-3 text-red">mdi-logout

              <RouterLink to="/authentication/login" class="menu-link" @click="handleLogout">
              </RouterLink>
            </v-icon>
            <span class="title">Logout</span>
            <!-- <span class="material-symbols-outlined menu-icon">logout</span> 
          </v-list-item> -->
          <v-list-item @click="handleLogout">
            <v-icon class="me-3 text-red">mdi-logout</v-icon>
            <span class="title">Logout</span>
          </v-list-item>

        </v-list>
      </v-card>
    </v-menu>
    <!-- <p> {{ profileStore.ProfileData.first_name }}</p>
    <p> {{ profileStore.ProfileData.image }}</p> -->
  </div>

</template>

<script setup>
import { ref, onMounted } from 'vue';
import banner1 from "@/assets/images/administrator.jpg";
import { useRouter } from 'vue-router';
import { useProfileStore } from "@/Store/profileStore";
const profileStore = useProfileStore();
import noImage from "@/assets/images/image_not_available-removebg-preview (1).png"

const router = useRouter();
const isDropdownOpen = ref(false);


const closeDropdown = () => {
  isDropdownOpen.value = false;
};

const handleLogout = async () => {
  try {

    localStorage.clear();
    sessionStorage.clear();
    router.replace("/authentication/login");;
  } catch (error) {
    console.error("Logout failed:", error);
  }
};


onMounted(async () => {
  await profileStore.fetchProfileData();
});


</script>


<style scoped>
/* Profile Card */
.profile-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Profile Header */
.profile-header {
  background: linear-gradient(135deg, #1976d2, #64b5f6);
  color: white;
  /* border-radius: 12px 12px 0 0; */
}

.profile-name {
  font-size: 16px;
  font-weight: bold;
}

.profile-role {
  font-size: 13px;
  opacity: 0.8;
}

/* Profile Menu */
.profile-menu .v-list-item {
  transition: background 0.3s;
}

.profile-menu .v-list-item:hover {
  background: rgba(25, 118, 210, 0.1);
  border-radius: 8px;
}
</style>
